import React from "react";
import LoadingView from "@/components/ui/loading-view/LoadingView";

const SessionForensicsView = React.lazy(
  () => import("./SessionForensics.view")
);

const SessionForensicsLoadable = () => (
  <React.Suspense fallback={<LoadingView />}>
    <SessionForensicsView />
  </React.Suspense>
);

export default () => <SessionForensicsLoadable />;
